import axios from '@axios';

export default {
  backToTerminal() {
    return axios.post('electron-log', JSON.stringify({ close: true }));
  },
};
